import { Skeleton } from "primereact/skeleton";

const SortListShimmer = () => {

  return (
    <>
   <div className="shimmer_ui">
    <span className="shimmer_rows shimmer_flex"> 
      {
        [...Array(1)].map((e, i) =>        
            <Skeleton className="c-skeleton" key={`TabListShiimer${i}`}></Skeleton>          
        )
      }
      </span>
    </div>
    </>
  );
};

export default SortListShimmer;
